"use client";

import { useState } from "react";

export function useFastBuy() {
  const [counter, setCounter] = useState(1);
  const [loading, setLoading] = useState(false);
  const [firstClick, setFirstClick] = useState(false);

  return {
    counter,
    loading,
    firstClick,
    setCounter,
    setLoading,
    setFirstClick
  };
}
